<template>
	<div class="header-banner">
		<template v-if="isEnableUpload">
			<template v-if="realRenderBanner">
				<div class="header-banner-mask">
					<div class="header-banner-change" @click="handleUploadBanner">
						<i class="iconfont icon-icon_shengchenghaibao"></i>
						<div>替换背景</div>
					</div>
				</div>
				<TransitionBanner :src="realRenderBanner" :visible="bannerRendered" />
			</template>
			<div v-else class="header-banner-upload">
				<el-image class="header-banner-upload-bg" :src="LAYOUT_UPLOAD_BG_IMG" fit="cover"></el-image>
				<div class="por" style="text-align: center">
					<div class="banner-upload-title">背景图</div>
					<div class="mt-8 banner-upload-desc">6:1，支持jpg、jpeg、png格式，大小不超过10M。</div>
					<el-button type="primary" size="medium" class="mt-16" @click="handleUploadBanner">上传</el-button>
				</div>
			</div>
		</template>
		<TransitionBanner v-else :src="realRenderBanner" :visible="bannerRendered" />
	</div>
</template>

<script setup>
import TransitionBanner from '@/views/layout/components/TransitionBanner.vue';
import { defineExpose } from 'vue';
import LAYOUT_UPLOAD_BG_IMG from '@/assets/images/layout_upload_bg.png';
import { useCurrentReactive } from './context';

const { isEnableUpload, realRenderBanner, bannerRendered, create, handleUploadBanner } = useCurrentReactive();

defineExpose({
	create
});
</script>

<style lang="less" scoped>
.header-banner {
	height: 460px;
	position: relative;
	background: #f7f8fa;

	.header-banner-mask {
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background: rgba(0, 0, 0, 0.6);
		display: flex;
		justify-content: center;
		align-items: center;
		z-index: 2;
		opacity: 0;
		transition: all 0.17s ease-in-out;
		cursor: pointer;

		.header-banner-change {
			padding: 0 16px;
			height: 32px;
			border-radius: 2px;
			background: #fff;
			color: #3964e5;
			display: inline-flex;
			align-items: center;

			.iconfont {
				font-size: 16px;
			}
			div {
				margin-left: 4px;

				font-size: 14px;

				font-weight: 400;
				line-height: 18px; /* 128.571% */
			}
		}
	}
	&:hover {
		.header-banner-mask {
			opacity: 1;
		}
	}
	.header-banner-upload {
		width: 100%;
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		background: #f7f8fa;
		position: relative;

		&-bg {
			position: absolute;
			top: 64px;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;
			max-width: 1380px;
		}
	}
	.banner-upload-title {
		color: #1d2129;

		font-size: 16px;

		font-weight: 600;
		line-height: 24px; /* 150% */
	}
	.banner-upload-desc {
		color: #86909c;

		font-size: 12px;

		font-weight: 400;
		line-height: 16px; /* 133.333% */
	}
}
</style>
